import {Anchor, createTopAnchor} from '@cypro/ui/components/ui/infinite-data-table'
import {queries} from '@/shared/integrations/zero'
import {ListUserGroupsInput} from '@cypro/engine/queries'
import {Group} from '@cypro/engine/schema'
import {useQuery} from '@rocicorp/zero/react'
import {useEffect, useState} from 'react'

export function useGetUserGroups(args: Omit<Partial<ListUserGroupsInput>, 'cursor'> = {}) {
  const {sort = {dir: 'asc', field: 'name'}, filters, limit = 50} = args
  const [anchor, setAnchor] = useState<Anchor<Group>>(createTopAnchor<Group>())

  const cursor =
    anchor.startRow?.id && anchor.startRow?.createdAt
      ? {id: anchor.startRow.id, createdAt: anchor.startRow.createdAt, direction: anchor.direction, name: anchor.startRow.name}
      : undefined

  const query = queries.userGroups.listUserGroups({
    cursor,
    limit,
    sort,
    filters,
  })

  const [groups, meta] = useQuery(query)

  useEffect(() => {
    setAnchor(createTopAnchor<Group>())
  }, [sort?.dir, sort?.field, filters?.search, limit])

  return {
    anchor,
    fetchMore: setAnchor,
    query,
    groups,
    meta,
    canFetchMore: groups.length === limit,
    isFetching: meta.type === 'unknown',
  }
}
